import { Link } from "react-router-dom";

import { Logo } from "../components/Logo";
import { SiteFooter } from "../components/SiteFooter";

export function Landing() {
  return (
    <>
      <div className="top-line" />
      <div className="page">
        <div className="card card--wide">
          <Logo size="xl" />
          <h1>Ready to light up your screens?</h1>
          <p className="sub">No credit card. No subscription. Just plug in a Pi and go.</p>
          <Link to="/login" className="btn btn--primary btn--cta">
            Sign In →
          </Link>
        </div>
      </div>
      <div className="bottom-line" />
      <SiteFooter />
    </>
  );
}
